module.exports = __webpack_public_path__ + "img/workflow_tumb.85eb051f.png";